module.exports = __webpack_public_path__ + "img/dealer-rater.8fe94581.png";